<div class="verify-container">
  <div class="verify-card">
    <img src="../../../../assets/images/logo.png" alt="PaperTrl logo" class="logo" />

    <h2 class="title">Something Went Wrong</h2>
    <p class="subtitle">
      We could not complete your login due to an authentication error.
      This may be caused by an expired link, missing permissions, or organization access restrictions.
    </p>

    <div class="actions">
<!--      <button class="btn btn-primary" (click)="onBackToLogin()">Back to Login</button>-->
      <button class="btn btn-logout" (click)="logout()">Logout</button>
    </div>

    <p class="footnote">
      If the issue continues, please contact
      <a href="mailto:support@papertrl.com">support@papertrl.com</a>.
    </p>
  </div>
</div>
